import {JourneyTrack} from '../journey-track';
import {TrackTypes} from '../model/track-types';
import {TrackInfo} from '../model/track-info';
import {TrackActionResult} from "../model/track-action-result";
import { OriginInvestActionV2 } from './actions/origin-v2-action';
import { OriginIncomeInvestActionV2 } from './actions/origin-income-v2-action';
import { CompanyActionV2 } from './actions/company-v2-action';
import { trackDefaultIncomeBasicV2 } from './util/track-default-income-v2';
import { environment } from '../../../../../../environments/environment';
import { DomainOrigin } from '../../../user-signup/model/domain-origin';

export class BasicProfessionalTrackV2 extends JourneyTrack {
  readonly originalTracks = [

    new TrackInfo('origin-income', ['professional-data', 'origin-income'], undefined, {
      undefined,
      actionName: ActionList.ActionOrigin
  }),
    new TrackInfo('profession', ['professional-data', 'profession'], undefined, {
      undefined,
      actionName: ActionList.ActionIncome
  }),
    new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj'], undefined, {
      undefined,
      actionName: ActionList.actionCompany
    }),
    ...trackDefaultIncomeBasicV2,
    new TrackInfo('client-data', ['data', 'client-data'], undefined, {dataOrigin: DomainOrigin[environment.registration]}),
    new TrackInfo('broker', ['broker']),
    new TrackInfo('terms', ['terms'], undefined, {domainOrigin: DomainOrigin[environment.registration]})
  ];

  track = [];

  constructor() {
    super();
    this.track = this.originalTracks;
  }

  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  getName(): TrackTypes {
    return TrackTypes.BASIC_V2;
  }

  async loadData(){
    throw new Error('Method not implemented.');
  }

  executeAction(actionName: any, data: any): TrackActionResult {
    switch (actionName) {
      case ActionList.ActionOrigin:
          return OriginInvestActionV2.execute(data, this.track, true);
      case ActionList.ActionIncome:
          return OriginIncomeInvestActionV2.execute(data);
      case ActionList.actionCompany:
          return CompanyActionV2.execute(data);
    }
  }

  isUncoupled() {
    return false;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }
}

export enum ActionList {
  ActionOrigin = 'actionOrigin',
  ActionIncome = 'actionIncome',
  actionCompany = 'actionCompany'
}
